'use strict';
import React, { Component } from 'react';

export class FooterBase extends Component {
    constructor(props) {
        super(props);
    }
}
